import React from 'react'
import { ReactComponent as Info } from '../../../assets/icons/outlined-info.svg'
import { ReactComponent as InfoGreen } from '../../../assets/icons/outlined-info-green.svg'
import { ReactComponent as ToCheckCircle } from '../../../assets/icons/oval.svg'
import { ReactComponent as FilledChecked } from '../../../assets/icons/filled-checked.svg'
import Tippy from '@tippyjs/react'

const CushionJointerTypeCard = ({ type, tooltipText, isActive, icon, onClickHandler }) => {

  const cardTitle = type === 'join' ? 'fabric connection' : type

  const tooltipContent = () => {
    return (
      <div className="tooltip-content jointer-tooltip-content">
        <h4>{cardTitle}</h4>
        <p>{tooltipText}</p>
      </div>
    )
  }

  return (
    <div
      className={`dimension-option-card-wrapper attribute jointer${isActive ? ' selected-type' : ''}`}
      onClick={onClickHandler}
    >
      <div id="type" className="image-background">
        <div className={`jointing-checkbox`}>
          {isActive ? <FilledChecked /> : <ToCheckCircle />}
        </div>
        <img alt="cushion" className={`type ${type === 'join' ? 'more-up' : ''}`} src={icon} />
      </div>
      <div className="dimensions-jointer-text-container">
        <p className="dimension-jointer-card-title">
          {cardTitle}
        </p>
        <div className={`jointer-tooltip ${isActive ? 'selected-type-tooltip' : ''}`}>
          <Tippy content={tooltipContent()} className="tooltip">
            {isActive ? (
              <InfoGreen
                className="info-icon"
                fill={`${isActive ? 'black' : 'white'}`}
                style={{
                  width: '1.55rem',
                  height: '1.55rem',
                }}
              />
            ) : (
              <Info
                className="info-icon"
                fill={`${isActive ? 'black' : 'white'}`}
                style={{
                  width: '1.55rem',
                  height: '1.55rem',
                }}
              />
            )}
          </Tippy>
        </div>
      </div>
    </div>
  )
}

export default CushionJointerTypeCard
